module.exports = __webpack_public_path__ + "img/profile.00be3fbb.jpg";